<template>
  <div class="newsSwiper" ref="swiper" :style="{width:width,height:height,radius}">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item,index) in list" :key="index">
        <div class="carousel-item" :style="{width:width,height:height,radius}">
          <router-link :to="{path:'/news/info',query:{newsId:item.id}}">
            <img class="newsBanner"
                 :style="{width:width,height:height,borderRadius:radius}"
                 :src="$api.baseUrl+$api.imgPath+item.pcImageUrl"
                 alt="">
          </router-link>
          <div class="title">{{ item.newsTitle }}</div>
        </div>
      </div>
    </div>
    <!-- <a-carousel v-if="type==1" :dots="true" ref="newsCarousel" autoplay>
      <div class="carousel-item" :style="{width:width,height:height,radius}" v-for="(item,index) in list" :key="index">
        <router-link :to="{path:'/news/info',query:{newsId:item.id}}"><img class="newsBanner" :style="{width:width,height:height,borderRadius:radius}"  :src="$api.baseUrl+$api.imgPath+item.pcImageUrl" alt=""></router-link>
        <div class="title">{{item.newsTitle}}</div>
      </div>
    </a-carousel>
    <a-carousel v-else :dots="true" ref="newsCarousel" autoplay>
      <div class="carousel-item" :style="{width:width,height:height,radius}" v-for="(item,index) in list" :key="index">
        <a href=""><img class="newsBanner" :style="{width:width,height:height,borderRadius:radius}"  :src="item.src" alt=""></a>
        <div class="title">{{item.title}}</div>
      </div>
    </a-carousel> -->
  </div>
</template>

<script>
export default {
  props: ["list", "width", "height", "radius", "type"],
  data() {
    return {
      swiperObj: {}
    }
  },
  mounted() {
    this.initSwiperTools()
    // this.newsCarouselAutoPlay();
  },
  methods: {
    // 初始化swiper插件
    initSwiperTools() {
      this.swiperObj = new Swiper(this.$refs.swiper, {
        autoplay: 3000,
        speed: 500,
        loop: true,
      });
    },
    // 新闻动态的幻灯片播放
    // newsCarouselAutoPlay() {
    // 	this.newsTimer = setInterval(() => {
    // 		this.$refs.newsCarousel.next();
    // 	}, 3000);
    // }
  }
}
</script>

<style scoped="scoped">
.newsSwiper {
  overflow: hidden;
}

.newsSwiper .carousel-item {
  position: relative;
}

.newsSwiper .title {
  position: absolute;
  bottom: 0px;
  color: white;
  width: 100%;
  font-size: 16px;
  background: #1A1A1A;
  padding: 20px;
  opacity: 0.7;
  border-radius: 0px 0px 4px 4px;
}

.newsBanner {
  object-fit: cover;
}
</style>
<style>
.newsSwiper .ant-carousel .slick-dots {
  width: auto !important;
  right: 20px;
  bottom: 40px;
}

.newsSwiper .slick-dots .slick-dots-bottom {
  bottom: 40px;
}

.newsSwiper .ant-carousel .slick-dots li button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/NewsSwiper.vue